import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchApi } from '../fetchApi';
import lockr from 'lockr';

const { REACT_APP_API_URL } = process.env;

const initialState = {};

/* =======================  AUTH  =======================*/
const registerCustomer = createAsyncThunk(
  'customers/registerCustomer',
  async (body) => {
    return await fetchApi(
      `${REACT_APP_API_URL}/customers`,
      'POST',
      { 'Content-type': 'application/json' },
      JSON.stringify(body),
    );
  },
);

const validateCustomerEmail = createAsyncThunk(
  'customers/validateCustomerEmail',
  async (body) => {
    return await fetchApi(
      `${REACT_APP_API_URL}/customers/validate-email`,
      'POST',
      { 'Content-type': 'application/json' },
      JSON.stringify(body),
    );
  },
);

const setChangePassword = createAsyncThunk(
  'customers/setChangePassword',
  async (form) => {
    const token = lockr.get('APP_AUTH_KEY');
    let headers = {
      'Content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    return await fetchApi(
      `${REACT_APP_API_URL}/customers/me/password`,
      'PATCH',
      headers,
      JSON.stringify(form),
    );
  },
);

/* =======================  ORDERS  =======================*/

const tagMember = createAsyncThunk('customers/tagMember', async (body) => {
  const token = lockr.get('APP_AUTH_KEY');
  let headers = {
    'Content-type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return await fetchApi(
    `${REACT_APP_API_URL}/me/orders/${body.order_id}/tags`,
    'POST',
    headers,
    JSON.stringify(body.form),
  );
});

const untagMemberTag = createAsyncThunk(
  'customers/untagMemberTag',
  async (body) => {
    const token = lockr.get('APP_AUTH_KEY');
    let headers = {
      'Content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    return await fetchApi(
      `${REACT_APP_API_URL}/me/orders/${body.order_id}/tags/${body.member_id}`,
      'DELETE',
      headers,
      null,
    );
  },
);

export const customersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {},
  extraReducers: {
    [registerCustomer.fulfilled]: (state, action) => {
      lockr.set('email', action?.meta?.arg?.email);
    },
  },
});

export const actions = {
  ...customersSlice.actions,
  registerCustomer,
  validateCustomerEmail,
  setChangePassword,
  tagMember,
  untagMemberTag,
};

export default customersSlice.reducer;
